import { Fragment } from 'react';
import { BKJBadge, BKJIcon } from '@bookjane2/bookjane-design-library';
import { JaneAvatar } from 'components/BKJJaneAvatar';
import { Flex } from 'components/Flex';
import { IShiftJane } from 'modals/ShiftModal/src/components/ShiftJane/ShiftJane.types';
import { UserGuard } from 'guards/UserGuard';
import { getShiftModalShiftJaneName } from 'mappers/shiftModalOrderDetailsMapper';
import { css } from 'styled-components';
import {
  Jane,
  JaneName,
  JaneFacility,
  ShiftJaneWrapper,
  AvatarIconWrapper,
  ShiftJaneStyledBKJIcon,
} from './ShiftJane.styled';
import { useShiftModalPropsContext } from 'modals/ShiftModal/ShiftModal.props.context';

export function ShiftJane(props: IShiftJane) {
  const { data, className } = props;
  const order = data?.order;
  const { isSharedJanePrimaryCommunityDifferentFromSelectedLocation } = useShiftModalPropsContext();
  if (!order?.mainJane) return null;
  return (
    <ShiftJaneWrapper className={className}>
      <Jane justifyContent="space-between" alignItems="center" width="100%">
        <Flex alignItems="center">
          <AvatarIconWrapper>
            <JaneAvatar
              url={order.mainJane.avatarUrls.small}
              status={order.status.value}
              css={css`
                margin-right: 13px;
              `}
              size={30}
              pendingSignup={false}
            />
            {order.mainJane.pendingSignup && (
              <ShiftJaneStyledBKJIcon iconName="PendingSignup" left="17" top="16" width="20" />
            )}
          </AvatarIconWrapper>
          <Flex flexDirection="column">
            <Flex alignItems="center">
              <JaneName>{getShiftModalShiftJaneName(order)}</JaneName>
              {isSharedJanePrimaryCommunityDifferentFromSelectedLocation && (
                <Fragment>
                  &nbsp; &nbsp;
                  <BKJIcon iconName="Group2" width={16} height={14} />
                </Fragment>
              )}
            </Flex>
            <JaneFacility>{order.mainJane.communityName}</JaneFacility>
          </Flex>
        </Flex>
        <UserGuard userType={['USER_TYPE_PREMIUM', 'USER_TYPE_PREMIUM_SECONDARY']}>
          {!!order.mainJane.agencyCommunity && !order.sentToAgencies && (
            <BKJBadge variant="Grey">Agency</BKJBadge>
          )}
        </UserGuard>
      </Jane>
    </ShiftJaneWrapper>
  );
}
